import { RadioLabel } from '@/components/radio/RadioLabel';
import { RHFRadioGroup } from '@/components/radio/RHFRadioGroup';
import { SearchHospitalsType } from '@/schemas/SearchParamsSchemas/app/stations/search/hospitals/Schema';
import {
  getSearchTypeLabel,
  STATION_ADVANCED_SEARCH_TYPES,
} from '@/types/types';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export function SearchTypeRadioGroup() {
  const { control, getValues } = useFormContext<SearchHospitalsType>();

  return (
    <Box>
      <RHFRadioGroup
        aria-labelledby={`radiogroup-search-type`}
        name={control.register('searchType').name}
        control={control}
        defaultValue={getValues('searchType')}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          {Object.values(STATION_ADVANCED_SEARCH_TYPES).map((type) => (
            <Box key={`search-type-${type}`}>
              <RadioLabel
                sx={{
                  color: '#13131D',
                  '&.Mui-checked': {
                    color: '#13131D',
                  },
                }}
                value={type}
                label={getSearchTypeLabel(type)}
              />
            </Box>
          ))}
        </Box>
      </RHFRadioGroup>
    </Box>
  );
}
